import dayjs from 'dayjs';

import type { Candidate } from '@entities/candidates';
import { formatCurrencyPaymentPeriod } from '@shared/helpers';

import type { CandidatePickCard } from '../types';

type VacancyPaymentDetails = {
  currency: string;
  paymentPeriod: string;
};

export const mapCandidateToPickCard = (
  candidate: Candidate,
  vacancyPaymentDetails: VacancyPaymentDetails
): CandidatePickCard => {
  const lastName = candidate.lastName ?? '';
  const lastInitial = lastName.trim()[0];
  const displayName = lastInitial
    ? `${candidate.firstName} ${lastInitial}.`
    : candidate.firstName;
  const activeResume = candidate.resumes.find(resume => resume.is_active);
  const formattedPeriod = formatCurrencyPaymentPeriod(
    vacancyPaymentDetails.currency,
    vacancyPaymentDetails.paymentPeriod
  );
  const salary =
    activeResume?.salary == null
      ? '—'
      : `${activeResume.salary} ${formattedPeriod}`.trim();

  return {
    candidateId: candidate.id,
    photoUrl: candidate.photo?.absolutePath ?? '',
    firstName: candidate.firstName,
    lastName,
    displayName,
    summary: candidate.summary?.trim() || '—',
    age: candidate.age,
    matchPercent: Math.round(candidate.matchPercent),
    analysis: candidate.analysis?.trim() || '—',
    readyToWorkDate: activeResume?.employmentDate
      ? dayjs(activeResume.employmentDate).format('DD.MM.YYYY')
      : '—',
    salary,
    phone: candidate.phone?.trim() || '—',
  };
};
